import useWebSocket from 'react-use-websocket';
import { webSocketUrl } from '../../webSocketUrl';

/**
 * Shared connection to the game WebSocket (`/game`).
 *
 * ref: https://www.npmjs.com/package/react-use-websocket
 *
 * `share: true` means every component that calls this hook reuses the single
 * underlying socket while getting its own `lastMessage`/`sendJsonMessage`. So
 * both the board (listening for game state frames) and the chat window
 * (listening for chat frames) can subscribe independently and each filter for
 * the frames it cares about.
 */
export const useGameWebSocket = () => {
  const { sendMessage, sendJsonMessage, lastMessage, lastJsonMessage, readyState, getWebSocket } =
    useWebSocket<{ data: any }>(webSocketUrl('/game'), {
      shouldReconnect: () => true,
      share: true,
    });

  return {
    sendMessage,
    sendJsonMessage,
    lastMessage,
    lastJsonMessage,
    readyState,
    getWebSocket,
  };
};
